import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { ErrorResponse } from './../../../models/error.model';
import { BrokersService } from './../../../services/brokers.service';
import { UtilsService } from './../../../services/utils.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Broker } from './../../../models/broker.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatStepper } from '@angular/material/stepper';
import { CSVColumnMap } from '../../generics/bulk-creator/bulk-creator.component';

@Component({
    selector: 'app-edit-broker',
    templateUrl: './edit-broker.component.html',
    styleUrls: ['./edit-broker.component.scss']
})
export class EditBrokerComponent implements OnInit {

    broker?: Broker;

    generalSectionFG = new UntypedFormGroup({
        nombre: new UntypedFormControl('', [Validators.required]),
        apellido: new UntypedFormControl('', [Validators.required]),
        celular: new UntypedFormControl('', [Validators.required]),
        cuit: new UntypedFormControl('', [Validators.required, Validators.minLength(11), Validators.maxLength(11), this.utilsService.numberFormValidator]),
    });

    credentialsSectionFG = new UntypedFormGroup({
        email: new UntypedFormControl('', [Validators.required, Validators.email])
    });

    @ViewChild('stepper', { static: true })
    stepper: MatStepper;

    bulkCreatorColumnMaps: CSVColumnMap[] = [
        { key: 'nombre', description: 'Nombre' },
        { key: 'apellido', description: 'Apellido' },
        { key: 'celular', description: 'Teléfono' },
        { key: 'cuit', description: 'CUIT' },
        { key: 'email', description: 'Email' },
    ];

    validatorFormGroup = new UntypedFormGroup({
        nombre: new UntypedFormControl('', [Validators.required]),
        apellido: new UntypedFormControl('', [Validators.required]),
        celular: new UntypedFormControl('', [Validators.required]),
        cuit: new UntypedFormControl('', [Validators.required, Validators.minLength(11), Validators.maxLength(11), this.utilsService.numberFormValidator]),
        email: new UntypedFormControl('', [Validators.required, Validators.email]),
    });

    constructor(
        private route: ActivatedRoute,
        private brokersService: BrokersService,
        private utilsService: UtilsService,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params?.id) {
                this.brokersService.getBrokerById(params.id).subscribe(broker => {
                    this.broker = broker;
                    this.fillFormsWithOwnerData();
                }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener datos del agente', error.error?.descripcion));
            }
        });
    }

    fillFormsWithOwnerData() {
        this.generalSectionFG.setValue({
            nombre: this.broker.nombre,
            apellido: this.broker.apellido,
            celular: this.broker.celular,
            cuit: this.broker.cuit
        });
        this.credentialsSectionFG.setValue({
            email: this.broker.email
        });
        this.credentialsSectionFG.controls.email.disable();
    }

    getResultingBroker() {
        return {
            id: this.broker?.id,
            nombre: this.generalSectionFG.value.nombre,
            apellido: this.generalSectionFG.value.apellido,
            celular: this.generalSectionFG.value.celular,
            cuit: this.generalSectionFG.value.cuit,
            email: this.credentialsSectionFG.value.email
        } as Broker;
    }

    createBroker() {
        if (!this.generalSectionFG.valid) {
            this.stepper.selectedIndex = 0;
            return;
        } else if (!this.broker && !this.credentialsSectionFG.valid) {
            this.stepper.selectedIndex = 1;
            return;
        }
        const broker: Broker = this.getResultingBroker();
        if (this.broker) {
            this.brokersService.editBroker(broker).subscribe(_ => {
                this.router.navigate(['agentes']);
            }, (error: ErrorResponse) => this.utilsService.alert('Error al modificar agente', error.error?.descripcion));
        } else {
            this.brokersService.createBroker(broker).subscribe(_ => {
                this.router.navigate(['agentes']);
            }, (error: ErrorResponse) => this.utilsService.alert('Error al crear agente', error.error?.descripcion));
        }
    }

    getBulkCreatorErrors = (row: any) => {
        const errors = [];
        if (row) {
            this.validatorFormGroup.setValue(row);
            Object.keys(this.validatorFormGroup.controls).map(controlName => {
                const control = this.validatorFormGroup.controls[controlName];
                if (!control.valid) {
                    Object.keys(control.errors).forEach(error => {
                        errors.push(`Campo: ${controlName}, error: ${error}.`);
                    });
                }
            });
        }
        return errors;
    }

    parsePhone(phoneString: string, index: number) {
        try {
            return this.utilsService.parsePhone(phoneString);
        } catch {
            throw new Error(`Error al parsear teléfono en la linea ${index + 1}, un ejemplo de teléfono correcto es: +54-911-22323223.`);
        }
    }

    bulkCreatorSubmit = async (values: any[]) => {
        const brokers = await Promise.all(values.map(async (row, index) => ({
            nombre: row.nombre,
            apellido: row.apellido,
            celular: this.parsePhone(row.celular, index),
            cuit: row.cuit,
            email: row.email
        } as Broker)));
        return await this.brokersService.bulkLoad(brokers).toPromise();
    }
}
